import { Typography } from "@mui/material";

const ReintegrosSteps = ({ actualStep, lastStep }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Typography variant="h5">
        Paso {actualStep} de {lastStep}:
      </Typography>
    </div>
  );
};

export default ReintegrosSteps;
